export const orders = {
  m1Title: "Incoming Inspection & Damage Assessment",
  m1DataProducedHeading: "Data produced",
  m1ServiceComponentsHeading: "Service component identity",
  m1ServiceComponentsHint:
    "Record the component or gear-unit serial once for the whole service.",
  m1AddComponent: "Add component",
  m1RemoveComponent: "Remove",
  m1NoComponents: "Add at least one service component.",
  m1ComponentSerialLabel: "Component {index} serial number",
  m1SerialLabel: "Gear unit serial number",
  m1SerialPlaceholder: "Enter serial number",
  m1EvidenceDimensional: "Dimensional measurements",
  m1EvidenceNdt: "Non-destructive inspection (NDT) reports",
  m1EvidenceVisual: "Visual inspection images",
  m1FormatPdf: "PDF",
  m1FormatImage: "Image",
  m1FormatText: "Text",
  m1SensitivityLabel: "Sensitivity",
  m1SensitivityConfidential: "Confidential",
  m1SensitivityIp: "IP",
  m1TextNotesLabel: "Notes",
  m1TextNotesPlaceholder: "Optional text evidence",
  m1UploadHint: "Drop files or click to upload",
  m1Uploading: "Uploading…",
  m1UploadFailed: "Upload failed. Please try again.",
  m1RemoveAttachment: "Remove file",
  m1SaveProgress: "Save progress",
  m1CompleteMilestone: "Complete Milestone 1",
  m1SavedToast: "M1 progress saved.",
  m1CompletedToast: "M1 completed.",
  m1ValidationNoFindings: "Add at least one service component.",
  m1ValidationNoComponents: "Add at least one service component.",
  m1ValidationSerialRequired: "Each service component needs a serial number.",
  m1ValidationComponentRequired:
    "Each service component needs a serial number.",
  m1ValidationEvidenceRequired:
    "Incoming inspection needs evidence in at least one section (measurements, NDT, or visual).",
  m2Title: "Repair / Refurbishment Completed",
  m2PurposeHeading: "Purpose of data",
  m2PurposeQualityAssurance: "Quality assurance",
  m2PurposeInternalTraceability: "Internal traceability",
  m2PostRepairMeasurements: "Post-repair measurements",
  m2HeatTreatmentReferences: "Heat treatment references",
  m2ProcessConfirmation: "Process confirmation (no detailed parameters)",
  m2SaveProgress: "Save progress",
  m2CompleteMilestone: "Complete Milestone 2",
  m2SavedToast: "M2 progress saved.",
  m2CompletedToast: "M2 completed.",
  m2ValidationPostRepairMeasurementsRequired:
    "Add post-repair measurements evidence.",
  m2ValidationHeatTreatmentReferencesRequired:
    "Add heat treatment reference evidence.",
  m2ValidationProcessConfirmationRequired: "Add process confirmation evidence.",
  m3Title: "Final Inspection & Certification Readiness",
  m3FinalInspectionReport: "Final inspection report",
  m3ServiceCompletionCopy:
    "This milestone represents service completion once the final inspection report is available.",
  m3ServiceCompletionConfirmLabel:
    "Yes, this milestone represents service completion.",
  serviceCompletionMarkHeading: "Mark this milestone as service completion",
  m3SaveProgress: "Save progress",
  m3CompleteMilestone: "Complete Milestone 3",
  m3SavedToast: "M3 progress saved.",
  m3CompletedToast: "M3 completed.",
  m3ValidationFinalInspectionReportRequired:
    "Add final inspection report evidence.",
  m3ValidationServiceCompletionRequired:
    "Confirm that this milestone represents service completion.",
  m3FollowUpMilestoneCopy:
    "Service continues after this milestone. Name the follow-up milestone below, then complete Milestone 3.",
  m3FollowUpMilestoneHint:
    "You can finish naming the next milestone here or continue after completing Milestone 3.",
  followUpMilestoneHeading: "Next milestone ({key})",
  followUpMilestoneHint:
    "You can name Milestone {number}'s successor here or continue after completing it.",
  followUpMilestoneDescription:
    "Name this milestone and confirm whether it completes the service.",
  followUpServiceCompletionCopy:
    "If unchecked, another milestone will be added after this one.",
  followUpDefaultTitle: "Milestone {number}",
  followUpValidationTitleRequired: "Enter a name for this milestone.",
  followUpValidationSectionRequired:
    "Add at least one documentation field with a label and evidence (notes or files).",
  followUpValidationSectionEvidenceRequired:
    "Add notes or files for this documentation field.",
  followUpValidationSectionLabelRequired:
    "Enter a field label and confirm it before adding evidence.",
  milestoneNameLabel: "Milestone name",
  milestoneNamePlaceholder: "Please enter milestone title",
  followUpSectionsHeading: "Documentation fields",
  followUpAddSection: "Add documentation field",
  followUpSectionLabel: "Field {index} label",
  followUpSectionLabelPlaceholder: "e.g. Part Replacement",
  followUpSectionConfirmLabelAria: "Confirm field label",
  followUpSectionEditLabelAria: "Edit field label",
  followUpRemoveSection: "Remove documentation field",
  followUpNoSectionsHint:
    "Add a documentation field to capture text, PDFs, images, and other evidence.",
  milestoneSaveProgress: "Save progress",
  milestoneCompleteNumber: "Complete Milestone {number}",
  milestoneCompleteService: "Complete Service",
  milestoneSavedToast: "Milestone {number} progress saved.",
  milestoneCompletedToast: "Milestone {number} completed.",
  milestoneEditTitleAria: "Edit milestone name",
  milestoneSaveTitleAria: "Save milestone name",
  milestoneCancelTitleAria: "Cancel editing milestone name",
  milestoneTitlePlaceholder: "Milestone name",
  milestoneStatusPending: "Pending",
  milestoneStatusInProgress: "In progress",
  milestoneStatusCompleted: "Completed",
  m1GearUnitsDocumented: "{count} service component(s) documented",
  milestoneEvidenceDocumented: "{count} evidence section(s) documented",
  ordersReceivedSaveError: "Could not save milestone data.",
  ordersReceivedMilestoneError: "Could not update service milestones.",
  dppEyebrow: "Digital Product Passport",
  dppIntro:
    "This passport combines the remanufacturing service data captured across all completed milestones.",
  dppBatteryIntro:
    "EU-aligned battery passport with verified identity, performance, sustainability, and compliance information for this asset.",
  dppBatteryPassportBadge: "Battery passport",
  dppLastUpdated: "Last updated",
  dppHeroPassportId: "Passport ID",
  dppHeroBatteryId: "Battery ID",
  dppHeroManufacturer: "Manufacturer",
  dppHeroChemistry: "Chemistry",
  dppHeroEnergy: "Energy",
  dppHeroMass: "Mass",
  dppHeroCarbonClass: "Carbon class",
  dppHeroStateOfEnergy: "State of energy",
  dppHeroStatus: "Status",
  dppCarbonFootprintHeading: "Sustainability",
  dppCarbonBreakdownTitle: "Carbon footprint breakdown",
  dppCarbonIntensity: "Intensity",
  dppAttachment: "Attachment",
  dppTampered: "Tampered",
  dppTamperedBanner: "One or more passport parameters are marked as tampered.",
  dppYes: "Yes",
  dppNo: "No",
  dppGearboxPassportBadge: "Gearbox passport",
  dppGearboxIntro:
    "Remanufactured wind-turbine gearbox passport with identity, quality release, delivery scope, and traceability for this asset.",
  dppHeroGearboxId: "Gearbox ID",
  dppHeroRemanufacturer: "Remanufacturer",
  dppHeroRatedPower: "Rated power",
  dppHeroTurbine: "Turbine",
  dppHeroTestResult: "Test result",
  dppHeroWarranty: "Warranty",
  dppHeroAvailability: "Availability",
  dppHeroStock: "Stock",
  dppGearboxQualityHeading: "Quality release",
  dppGearboxQualityTitle: "Inspection and documentation",
  dppGearboxTestRun: "Test run",
  dppGearboxQualityRelease: "Released",
  dppGearboxInitialInspection: "Initial inspection",
  dppGearboxConditionAssessment: "Condition assessment",
  dppGearboxFinalInspection: "Final inspection",
  dppGearboxWarrantyProvided: "Warranty",
  dppGearboxRepairDocs: "Repair documentation",
  dppGearboxTestDocs: "Test documentation",
  dppGearboxWarrantyDocs: "Warranty documentation",
  dppGearboxVibration: "Vibration",
  dppGearboxTemperature: "Temperature",
  dppGearboxLeakage: "Leakage",
  dppGearboxIncluded: "Included",
  dppGearboxNotIncluded: "Not included",
  dppGearboxDeliveryHeading: "Scope of delivery",
  dppGearboxExternalAccessories: "External accessories",
  dppGearboxShrinkDisk: "Shrink disk",
  dppGearboxBrake: "Brake system",
  dppGearboxRemanHeading: "Remanufacturing",
  dppGearboxRemanTitle: "Release record",
  dppGearboxRemanDate: "Remanufactured",
  dppGearboxRemanLocation: "Location",
  dppGearboxFinalCondition: "Final condition",
  dppGearboxReadiness: "Readiness",
  dppGearboxLeadTime: "Lead time",
  serviceWorkflowPhase_eoi_received: "Expression of interest",
  serviceWorkflowPhase_cancelled: "Cancelled",
  serviceWorkflowPhase_feasibility_declined: "Not feasible",
  serviceWorkflowPhase_awaiting_quote: "Awaiting quote",
  serviceWorkflowPhase_quote_sent: "Quote sent",
  serviceWorkflowPhase_quote_expired: "Quote expired",
  serviceWorkflowPhase_quote_accepted: "Quote accepted",
  serviceWorkflowPhase_milestones: "In progress",
  serviceWorkflowPhase_completed: "Completed",
  serviceWorkflowProviderEoiPending:
    "Review the request details and submit a feasibility verdict.",
  serviceWorkflowCustomerEoiPending:
    "The provider is reviewing your expression of interest.",
  serviceWorkflowCatalogMilestonesNext:
    "Quote accepted. Catalog milestone builder arrives in the next release — the order is ready for provider-defined milestones.",
  serviceEoiFormTitle: "Express interest in this service",
  serviceEoiFormIntro:
    "Tell the provider about the asset and delivery expectations for {{productName}}.",
  serviceEoiAssetDescription: "Asset / scope description",
  serviceEoiAssetDescriptionPlaceholder:
    "Describe the component, damage, or work scope the provider should assess.",
  serviceEoiAssetDescriptionRequired:
    "Please describe the asset or scope for this service request.",
  serviceEoiRequestedDelivery: "Requested delivery date",
  serviceEoiCustomerReference: "Your reference (optional)",
  serviceEoiCustomerReferencePlaceholder: "PO, project code, or internal ref",
  serviceEoiAdditionalNotes: "Additional notes",
  serviceEoiAdditionalNotesPlaceholder:
    "Constraints, standards, or site access details.",
  serviceEoiMessageOptional: "Message to provider (optional)",
  serviceEoiMessagePlaceholder: "Short note shown with the request.",
  serviceEoiSubmit: "Send expression of interest",
  serviceEoiSubmitting: "Sending…",
  serviceEoiRequestBriefEyebrow: "Customer request brief",
  serviceEoiDetailsHeading: "Expression of interest details",
  serviceEoiCustomerMessage: "Message from customer",
  serviceEoiSectionContact: "Customer & site",
  serviceEoiSectionMachine: "Machine & repair scope",
  serviceEoiSectionRequirements: "Technical requirements",
  serviceEoiSectionPartAndDelivery: "Part size & delivery",
  serviceEoiCompany: "Company",
  serviceEoiPlantLocation: "Plant / site location",
  serviceEoiCountry: "Country",
  serviceEoiContactName: "Contact person",
  serviceEoiContactEmail: "Contact email",
  serviceEoiContactPhone: "Contact phone",
  serviceEoiRepairDescription: "Description of required repair",
  serviceEoiRepairDescriptionPlaceholder:
    "Describe the component, damage, and work scope the provider should assess.",
  serviceEoiRepairDescriptionRequired:
    "Please describe the repair work required for this request.",
  serviceEoiTagNumber: "Machine TAG number",
  serviceEoiOemBrand: "OEM brand",
  serviceEoiMachineModel: "Model",
  serviceEoiMachineCategory: "Machine category",
  serviceEoiMachineType: "Machine type",
  serviceEoiMachineSerialNumber: "Machine serial number",
  serviceEoiSectionMachinePart: "Machine part",
  serviceEoiPartCategory: "Part category",
  serviceEoiPartTypeKnown: "Part type is known",
  serviceEoiPartType: "Part type",
  serviceEoiPartSerialNumber: "Part serial number",
  serviceEoiPartAvailableForRefurbishment: "Available for refurbishment",
  serviceEoiPartCurrentCondition: "Current condition",
  serviceEoiPartOperatingHours: "Operating hours",
  serviceEoiPartFailureDescription: "Failure description",
  serviceEoiPartKnownDamage: "Known damage",
  serviceEoiSectionServiceRequirements: "Service requirements",
  serviceEoiRequestedServiceScope: "Requested service scope",
  serviceEoiScopeDescription: "Scope description",
  serviceEoiAccessoriesIncluded: "Accessories included",
  serviceEoiIncludedAccessories: "Included accessories",
  serviceEoiAccessoriesRequiredAfterService:
    "Accessories required after service",
  serviceEoiAccessoryName: "Accessory name",
  serviceEoiAddAccessory: "Add accessory",
  serviceEoiServiceAdditionalRequirements: "Additional requirements",
  serviceEoiSectionTesting: "Testing requirements",
  serviceEoiRequestedTestRun: "Requested test run",
  serviceEoiCustomerSpecificTestRequirements:
    "Customer-specific test requirements",
  serviceEoiTestReportRequired: "Test report required",
  serviceEoiSectionCommercial: "Commercial requirements",
  serviceEoiQuotationRequested: "Quotation requested",
  serviceEoiWarrantyRequested: "Warranty requested",
  serviceEoiWarrantyRequirements: "Warranty requirements",
  serviceEoiYes: "Yes",
  serviceEoiNo: "No",
  serviceEoiMaterialsHeatTreatment: "Material / heat treatment requirements",
  serviceEoiStandardsCodes: "Standards or codes to follow",
  serviceEoiNdtRequirements: "NDT requirements",
  serviceEoiAcceptanceCriteria: "NDT acceptance criteria",
  serviceEoiPartSizeHint:
    "Maximum part dimensions and weight help the provider assess feasibility.",
  serviceEoiMaxLength: "Max length",
  serviceEoiMaxWidth: "Max width",
  serviceEoiMaxHeight: "Max height",
  serviceEoiMaxWeight: "Max weight",
  serviceEoiPartSizeUnit: "Unit",
  serviceEoiPartSizeUnitFor: "Unit for {{dimension}}",
  serviceEoiPartSizeSummary: "Maximum part size",
  serviceEoiDrawingsHeading: "Drawings & repair location",
  serviceEoiDrawingsIntro: "Drawings which help to understand:",
  serviceEoiDrawingsBulletLocation: "the location of the repair",
  serviceEoiDrawingsBulletTolerances: "the required dimensional tolerances",
  serviceEoiDrawingsBulletMaxSizes: "the max sizes of the part to be repaired",
  serviceEoiDrawingsUploadHeading: "Upload drawings or images",
  serviceEoiDrawingsUploadHint:
    "Drag files here or click to upload (PDF, images, CAD, Office)",
  serviceEoiRepairLocationNotes: "Repair location notes",
  serviceEoiRepairLocationNotesPlaceholder:
    "Describe where the repair is needed and reference drawing numbers.",
  serviceEoiDrawingNotes: "Drawings & repair location notes",
  serviceEoiDrawingNotesPlaceholder:
    "Where the repair is needed, reference drawing numbers, etc.",
  serviceEoiToleranceNotes: "Required dimensional tolerances",
  serviceEoiToleranceNotesPlaceholder: "Tolerance values or standards to meet.",
  serviceEoiPhotosAttachmentsHeading: "Photos & other documents",
  serviceEoiPhotosAttachmentsHint:
    "Additional photos of damage or supporting documents (optional).",
  serviceEoiAttachmentsHeading: "Drawings, photos & documents",
  serviceEoiAttachmentsHint:
    "Upload PDF, images, Office, or CAD files (optional). Up to 20 files.",
  serviceEoiAttachmentsUploadHint: "Drag files here or click to upload",
  serviceEoiAttachmentsUploadFailed: "Could not upload file. Try again.",
  serviceEoiAttachmentsMax: "Maximum number of attachments reached.",
  serviceEoiAttachmentsTypeRejected: "File type not accepted for this request.",
  serviceEoiAttachmentCategory: "File category",
  serviceEoiAttachmentCategoryDrawing: "Drawing",
  serviceEoiAttachmentCategoryPhoto: "Photo",
  serviceEoiAttachmentCategoryOther: "Other",
  serviceEoiAttachmentCategory_drawing: "Drawing",
  serviceEoiAttachmentCategory_photo: "Photo",
  serviceEoiAttachmentCategory_nameplatePhoto: "Nameplate photo",
  serviceEoiAttachmentCategory_overviewPhoto: "Overview photo",
  serviceEoiAttachmentCategory_damagePhoto: "Damage photo",
  serviceEoiAttachmentCategory_conditionReport: "Condition report",
  serviceEoiAttachmentCategory_other: "Other",
  serviceFeasibilityHeading: "Feasibility review",
  serviceFeasibilityIntro:
    "Confirm whether you can prepare a commercial quote for this request.",
  serviceFeasibilityWillQuote: "Feasible — I will prepare a quote",
  serviceFeasibilityDecline: "Not feasible — decline request",
  serviceFeasibilityNote: "Note to customer (optional)",
  serviceFeasibilitySubmit: "Submit feasibility",
  serviceFeasibilitySuccess: "Feasibility decision saved.",
  serviceFeasibilityError: "Could not save feasibility decision.",
  serviceQuoteHeading: "Commercial quote",
  serviceQuoteIntro:
    "Send price, delivery, and expiry for the customer to accept.",
  serviceQuoteAmount: "Quoted amount",
  serviceQuoteCurrency: "Currency",
  serviceQuoteDeliveryDate: "Proposed delivery date",
  serviceQuoteExpiresAt: "Quote valid until",
  serviceQuoteNote: "Quote notes (optional)",
  serviceQuoteSubmit: "Send quote to customer",
  serviceQuoteResendIntro:
    "The previous quote expired. Send an updated price, delivery, and expiry for the customer.",
  serviceQuoteResendSubmit: "Send updated quote",
  serviceQuoteSentHeading: "Commercial quote sent",
  serviceQuoteSentBadge: "Sent to customer",
  serviceQuoteSentIntro:
    "Waiting for the customer to review and accept this quote.",
  serviceQuoteSentAcceptedIntro:
    "The customer accepted this quote. Milestone work can continue below.",
  serviceQuoteSentExpiredIntro:
    "This quote has expired. Issue a new quote using the form below when you are ready.",
  serviceQuoteSuccess: "Quote sent to customer.",
  serviceQuoteError: "Could not send quote.",
  serviceQuoteAcceptHeading: "Provider quote",
  serviceQuoteReviewIntro:
    "Review the commercial terms below. Accept to authorize the provider to start service work.",
  serviceQuoteAcceptedHeading: "Accepted commercial quote",
  serviceQuoteAcceptedBadge: "Accepted",
  serviceQuoteAcceptedIntro:
    "You accepted these commercial terms. The provider will execute the service against this agreement.",
  serviceQuoteAcceptedAt: "Accepted on",
  serviceQuoteAcceptedPendingHeading: "What happens next",
  serviceQuoteAcceptedPendingMilestonePlan:
    "The provider is preparing the milestone plan for your service. You will see progress here once work is scheduled.",
  serviceQuoteAcceptedPendingMilestones:
    "Service milestones are in progress. Track delivery and evidence below.",
  serviceQuoteAcceptedPendingCompleted:
    "All service milestones are complete. Review the digital product passport when available.",
  serviceQuoteExpiredMessage:
    "This quote has expired. Ask the provider to issue a new quote.",
  serviceQuotePoReference: "Purchase order reference (optional)",
  serviceQuoteAcceptSubmit: "Accept quote & start service",
  serviceQuoteAcceptSuccess: "Quote accepted. Service work can begin.",
  serviceQuoteAcceptError: "Could not accept quote.",
  servicePassportUpdatedDimensionsHeading: "Updated part dimensions",
  servicePassportUpdatedDimensionsIntro:
    "Latest as-measured max length, width, height, and weight recorded for this service.",
  serviceDppEyebrow: "Service Digital Product Passport",
  serviceDppIntro:
    "This passport is built from completed catalog milestones on this service order only. It is separate from the product listing passport.",
  catalogMilestoneBuilderHeading: "Build milestone plan",
  catalogMilestoneBuilderIntro:
    "Select activities and create as many milestones as this order needs. Finalize the plan when its structure is complete.",
  catalogMilestoneApplyActivities: "Apply activities to milestone",
  catalogMilestoneActivitiesMissing:
    "No activities are attached to this milestone yet. Select the activities that belong here, then apply them before marking progress.",
  catalogMilestoneCompletionHint: "Before completing this milestone:",
  catalogMilestoneAdvanceHint:
    "Complete this milestone to unlock the next step in the plan.",
  catalogMilestoneTitleLabel: "Milestone title (optional)",
  catalogMilestoneTitlePlaceholder: "e.g. Incoming inspection package",
  catalogMilestoneCreate: "Create Milestone",
  catalogMilestoneFinalizePlan: "Finalize Plan",
  catalogMilestoneFinalizeConfirmTitle: "Finalize this plan?",
  catalogMilestoneFinalizeConfirmOne:
    "Finalize this plan with 1 milestone? The milestone name, activities, and count cannot be changed afterward.",
  catalogMilestoneFinalizeConfirmMany:
    "Finalize this plan with {count} milestones? The milestone names, activities, order, and count cannot be changed afterward.",
  catalogMilestoneActivityCount: "activities",
  catalogMilestoneItemCount:
    "{activities} activities · {parameters} updated parameters",
  catalogActivitySelectorEmpty:
    "No catalog activities or updated parameters are available for this milestone.",
  catalogParameterSelectorHeading: "Updated parameters",
  catalogParameterSelectorLegend:
    "Dimensions declared in the customer express of interest can be re-measured and recorded in milestones.",
  catalogParameterProgressTypeUpdated: "Updated",
  catalogParameterEoiBaseline: "EOI: {{value}}",
  catalogParameterValueLabel: "Updated value",
  catalogUpdatedParameterLabel: "Updated {{dimension}}",
  catalogFinalParametersHeading: "Final part dimensions",
  catalogFinalParametersIntro:
    "Record the as-measured max length, width, height, and weight before completing the remanufacturing service. All four values are required.",
  catalogFinalParameterRequired: "Required",
  catalogParameterComparison: "EOI {{eoiValue}} → updated {{updatedValue}}",
  catalogParameterComparisonDetailed:
    "EOI {{eoiValue}} → updated {{updatedValue}} ({{delta}})",
  catalogParameterComparisonNoChange: "no change",
  catalogParameterComparisonIncrease: "+{{amount}} {{unit}} vs EOI",
  catalogParameterComparisonDecrease: "−{{amount}} {{unit}} vs EOI",
  catalogValidationParameterIncomplete:
    "Enter an updated value for every selected dimension before completing this milestone.",
  catalogValidationFinalParametersIncomplete:
    "Enter all four updated dimensions (max length, width, height, and weight) before completing the service.",
  catalogParameterSelectorNoEoiDimensions:
    "Updated dimensions (e.g. Updated width, Updated weight) appear here when the customer declared max length, width, height, or weight on the express of interest. This order has no part dimensions on file — submit a new commercial EOI with those fields filled, or ask the backend to return serviceWorkflow.eoiDetails.partConstraints.",
  catalogParameterSelectorAllRecorded:
    "All EOI dimensions for this order were already recorded in a completed milestone and are no longer selectable.",
  catalogMilestoneRemoveFromPlan: "Remove",
  catalogMilestonePlanSaved: "Milestone plan finalized.",
  catalogMilestonePlanSaveError: "Could not save milestones.",
  catalogMilestoneProgressSaved: "Milestone progress saved.",
  catalogMilestoneCompletedToast: "Milestone completed.",
  catalogMilestoneComplete: "Complete Milestone",
  catalogMilestonePlanExecutionComplete:
    "All milestones in this plan are complete.",
  catalogActivityDone: "Done",
  catalogActivityMarkDone: "Mark done",
  catalogActivityProgressLabel: "Progress",
  catalogActivityProgressPercentInput: "Completion percentage",
  catalogActivityProgressTypePercent: "% completion",
  catalogActivityProgressTypeDoneTick: "Done tick",
  catalogActivityPercentHint:
    "Enter progress for this milestone (0–100). You can save partial progress, but this activity must reach 100% before completing the milestone.",
  catalogActivitySelectorLegend:
    "Activities marked “% completion” show a numeric progress field on the milestone dashboard. “Done tick” activities use a single completion checkbox.",
  catalogOutcomeFilesHeading: "Milestone outcome files",
  catalogOutcomeFilesHint:
    "Optionally upload certificates, reports, photos, or other files for this milestone.",
  catalogOutcomeUploadHint: "Drop files or click to upload outcome files",
  catalogOutcomeUploadFailed: "Outcome file upload failed.",
  catalogOutcomeFilesEmpty: "No outcome files uploaded yet.",
  catalogOutcomeDownload: "Download",
  catalogOutcomeReplace: "Replace",
  milestoneRegistryError:
    "Could not register the milestone documents. The milestone was still saved.",
  catalogValidationActivitiesRequired:
    "Add at least one activity to the milestone.",
  catalogValidationActivitiesIncomplete:
    "Complete every activity before finishing the milestone.",
  catalogValidationDoneTickIncomplete:
    "Mark every done/tick activity as done before completing this milestone.",
  catalogValidationPercentIncomplete:
    "Bring every percent-based activity in this milestone to 100% before completing it.",
  catalogValidationPercentOutOfRange:
    "Enter a progress value between 0 and 100.",
  catalogValidationOrderPercentIncomplete:
    "Bring every percent-based activity to 100% across milestones before completing the service.",
  catalogValidationOrderDoneTickIncomplete:
    "Complete every done/tick activity across the service plan before finishing.",
  catalogValidationOrderActivitiesIncomplete:
    "Finish recording every planned activity before completing the service.",
  catalogValidationOutcomeFilesRequired:
    "Upload at least one outcome file for this milestone.",
  catalogApiStaleMilestonePercentRule:
    "The API still requires 100% on percent-based activities for this milestone. Partial progress (e.g. 43%) is valid in the app — restart the dev server after pulling the latest frontend, or ask backend to deploy updated catalog milestone rules.",
  catalogValidationServiceCompletionRequired:
    "Confirm service completion on the final milestone.",
  catalogMilestoneProgressEmpty: "No milestones have been defined yet.",
  catalogServiceDppReadyHint:
    "All milestones are complete. The service passport is available below.",
  serviceDppPreviewEyebrow: "Service passport preview",
  serviceDppPreviewIntro:
    "Preview built from completed milestones so far. The final passport is published when the full plan is complete.",
  customerDeliveryTeaserEyebrow: "Service complete",
  customerDeliveryTeaserTitle: "Your remanufacturing delivery pack is ready",
  customerDeliveryTeaserSummary:
    "{milestones} milestones finished · {documents} certificate{documentPlural}",
  customerDeliveryOpenPack: "Open delivery pack",
  customerDeliveryOpenPackAria:
    "Open your service delivery pack with milestones, documents, and digital passport",
  customerDeliveryModalTitle: "Service delivery pack",
  customerDeliveryModalIntro:
    "Everything your provider recorded for this completed remanufacturing service.",
  customerDeliveryOverviewHeading: "At a glance",
  customerDeliveryMilestonesLabel: "Milestones",
  customerDeliveryDocumentsLabel: "Certificates & files",
  customerDeliveryDocumentsJumpAria: "Scroll to download your documents",
  customerDeliveryTimelineHeading: "Work completed",
  customerDeliveryTimelineIntro:
    "Each step below summarizes provider-recorded activities for this order.",
  customerDeliveryDocumentsHeading: "Download your documents",
  customerDeliveryDocumentsIntro:
    "Outcome certificates and reports uploaded when milestones were completed.",
  customerDeliveryRequestHeading: "Your original request",
  customerDeliveryQuoteHeading: "Agreed commercial terms",
  customerDeliveryActivityCount: "{count} activities",
  customerDeliveryAllActivitiesDone: "All activities completed",
  customerDeliveryNoDocuments:
    "No downloadable files were attached to milestones.",
  customerDeliveryFinalParametersHeading: "Final part dimensions",
  customerDeliveryFinalParametersIntro:
    "As-measured max length, width, height, and weight recorded by your provider before service completion.",
};
